import React from 'react';
import { Box } from '@mui/material';
import SystemVehiclesDashboard from '../../components/maintenance/systemVehicle/SystemVehiclesDashboard';

const SistemasVehiculoPage = () => {  

  return (
    <Box sx={{ p: 2 }}>
      <SystemVehiclesDashboard
        onReorder={(newOrder) => {
          console.log('Nuevo orden de sistemas vehiculares:', newOrder);
        }}
      />
    </Box>
  );
};

export default SistemasVehiculoPage;